module.exports = __webpack_public_path__ + "static/img/All@3x.c85df2fa.jpg";